import PageTransition from "@/components/site/PageTransition";
import PageHero from "@/components/site/PageHero";
import SectionGlow from "@/components/site/SectionGlow";
import WorkEditorial from "@/components/site/WorkEditorial";

export default function WorkPage() {
    return (
        <PageTransition>
            <PageHero
                crumbs={[{ label: "Home", to: "/" }, { label: "Work" }]}
                eyebrow="Selected Work"
                title="Brands we've {gold:repositioned}."
                intro="A selection of identity systems, logo work, and creative direction across industries and continents."
                tone="cool"
            />
            <section className="pg-section" style={{ paddingTop: 0 }} data-testid="portfolio-section" aria-label="Work grid">
                <SectionGlow tone="cool" />
                <div className="pg-container">
                    <WorkEditorial showFilters />
                </div>
            </section>
        </PageTransition>
    );
}
